import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enAuth from './locales/en/auth.json';
import enAuthorization from './locales/en/authorization.json';
import enCarriers from './locales/en/carriers.json';
import enCommon from './locales/en/common.json';
import enExcludedProducts from './locales/en/excluded-products.json';
import enHelp from './locales/en/help.json';
import enOrders from './locales/en/orders.json';
import enPickupOrders from './locales/en/pickup-orders.json';
import enPlan from './locales/en/plan.json';
import enMarkets from './locales/en/markets.json';
import enSetup from './locales/en/setup.json';
import enSettings from './locales/en/settings.json';
import enShipments from './locales/en/shipments.json';
import enWidgets from './locales/en/widgets.json';

import plAuth from './locales/pl/auth.json';
import plAuthorization from './locales/pl/authorization.json';
import plCarriers from './locales/pl/carriers.json';
import plCommon from './locales/pl/common.json';
import plExcludedProducts from './locales/pl/excluded-products.json';
import plHelp from './locales/pl/help.json';
import plOrders from './locales/pl/orders.json';
import plPickupOrders from './locales/pl/pickup-orders.json';
import plPlan from './locales/pl/plan.json';
import plMarkets from './locales/pl/markets.json';
import plSetup from './locales/pl/setup.json';
import plSettings from './locales/pl/settings.json';
import plShipments from './locales/pl/shipments.json';
import plWidgets from './locales/pl/widgets.json';

import frAuth from './locales/fr/auth.json';
import frAuthorization from './locales/fr/authorization.json';
import frCarriers from './locales/fr/carriers.json';
import frCommon from './locales/fr/common.json';
import frExcludedProducts from './locales/fr/excluded-products.json';
import frHelp from './locales/fr/help.json';
import frOrders from './locales/fr/orders.json';
import frPickupOrders from './locales/fr/pickup-orders.json';
import frPlan from './locales/fr/plan.json';
import frMarkets from './locales/fr/markets.json';
import frSetup from './locales/fr/setup.json';
import frSettings from './locales/fr/settings.json';
import frShipments from './locales/fr/shipments.json';
import frWidgets from './locales/fr/widgets.json';

import esAuth from './locales/es/auth.json';
import esAuthorization from './locales/es/authorization.json';
import esCarriers from './locales/es/carriers.json';
import esCommon from './locales/es/common.json';
import esExcludedProducts from './locales/es/excluded-products.json';
import esHelp from './locales/es/help.json';
import esOrders from './locales/es/orders.json';
import esPickupOrders from './locales/es/pickup-orders.json';
import esPlan from './locales/es/plan.json';
import esMarkets from './locales/es/markets.json';
import esSetup from './locales/es/setup.json';
import esSettings from './locales/es/settings.json';
import esShipments from './locales/es/shipments.json';
import esWidgets from './locales/es/widgets.json';

import itAuth from './locales/it/auth.json';
import itAuthorization from './locales/it/authorization.json';
import itCarriers from './locales/it/carriers.json';
import itCommon from './locales/it/common.json';
import itExcludedProducts from './locales/it/excluded-products.json';
import itHelp from './locales/it/help.json';
import itOrders from './locales/it/orders.json';
import itPickupOrders from './locales/it/pickup-orders.json';
import itPlan from './locales/it/plan.json';
import itMarkets from './locales/it/markets.json';
import itSetup from './locales/it/setup.json';
import itSettings from './locales/it/settings.json';
import itShipments from './locales/it/shipments.json';
import itWidgets from './locales/it/widgets.json';

export const SUPPORTED_LOCALES = ['en', 'pl', 'fr', 'es', 'it'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const NAMESPACES = [
  'common',
  'auth',
  'authorization',
  'settings',
  'orders',
  'shipments',
  'markets',
  'carriers',
  'excluded-products',
  'help',
  'pickup-orders',
  'widgets',
  'setup',
  'plan',
] as const;

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    authorization: enAuthorization,
    settings: enSettings,
    orders: enOrders,
    shipments: enShipments,
    markets: enMarkets,
    carriers: enCarriers,
    'excluded-products': enExcludedProducts,
    help: enHelp,
    'pickup-orders': enPickupOrders,
    widgets: enWidgets,
    setup: enSetup,
    plan: enPlan,
  },
  pl: {
    common: plCommon,
    auth: plAuth,
    authorization: plAuthorization,
    settings: plSettings,
    orders: plOrders,
    shipments: plShipments,
    markets: plMarkets,
    carriers: plCarriers,
    'excluded-products': plExcludedProducts,
    help: plHelp,
    'pickup-orders': plPickupOrders,
    widgets: plWidgets,
    setup: plSetup,
    plan: plPlan,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    authorization: frAuthorization,
    settings: frSettings,
    orders: frOrders,
    shipments: frShipments,
    markets: frMarkets,
    carriers: frCarriers,
    'excluded-products': frExcludedProducts,
    help: frHelp,
    'pickup-orders': frPickupOrders,
    widgets: frWidgets,
    setup: frSetup,
    plan: frPlan,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    authorization: esAuthorization,
    settings: esSettings,
    orders: esOrders,
    shipments: esShipments,
    markets: esMarkets,
    carriers: esCarriers,
    'excluded-products': esExcludedProducts,
    help: esHelp,
    'pickup-orders': esPickupOrders,
    widgets: esWidgets,
    setup: esSetup,
    plan: esPlan,
  },
  it: {
    common: itCommon,
    auth: itAuth,
    authorization: itAuthorization,
    settings: itSettings,
    orders: itOrders,
    shipments: itShipments,
    markets: itMarkets,
    carriers: itCarriers,
    'excluded-products': itExcludedProducts,
    help: itHelp,
    'pickup-orders': itPickupOrders,
    widgets: itWidgets,
    setup: itSetup,
    plan: itPlan,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    defaultNS: 'common',
    ns: NAMESPACES,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export function resolveLocale(language: string | undefined): SupportedLocale {
  if (!language) return 'en';
  const base = language.toLowerCase().split('-')[0];
  return (SUPPORTED_LOCALES as readonly string[]).includes(base) ? (base as SupportedLocale) : 'en';
}

const INTL_LOCALES: Record<SupportedLocale, string> = {
  en: 'en-US',
  pl: 'pl-PL',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
};

export function toIntlLocale(locale: SupportedLocale): string {
  return INTL_LOCALES[locale];
}

export default i18n;
